/**
 * APP 共通関数など
 */
import { error_message as lang_error } from '@/lang/ja_JP'
import Api from "@/repositories/api";
const c207CheckSalesChannel = Api.get('c207CheckSalesChannel');

export default {
  data () {
    return {
      errors: [], // エラーメッセージ
      isLoading: false, // 読み込み中フラグ

      // [NEO 申込] アンカー一覧
      neoAnchorList: [
        '#plan',             // 0
        '#app-suite',        // 1
        '#web-conferencing', // 2
        '#option-service',   // 3
        '#security-option',  // 4
        '#mail-service',     // 5
        '#sub-domain',       // 6
        '#estimate',         // 7
        '#migration-url',    // 8
        '#preferred-date',   // 9
        '#remarks',          // 10
        '#provision'         // 11
      ],
      // [Chat 申込] アンカー一覧
      chatAnchorList: [
        '#chat-user',            // 0
        '#chat-option-service',  // 1
        '#chat-security-option', // 2
        '#chat-sub-domain',      // 3
        '#chat-estimate',        // 4
        '#chat-migration',       // 5
        '#preferred-date',       // 6
        '#chat-remarks',         // 7
        '#chat-provision'        // 8
      ],

      // 403（権限）エラーのエラーメッセージ
      forbidden_message: '権限がありません。',

      // 定義値
      // 契約状況
      VAL_CONTRACT_STATUS: {
        APPLY: '3',
      }
    }
  },
  methods: {
    /**
     * 受け入れ可能営業日
     */
    returnDisabledWorkableDays() {
      return 3;
    },

    /**
     * フラグ値を定義値に変換する
     * @param {string|number} flag フラグ値
     * @param {object|array} option フラグ値と定義値の配列
     * @returns 表示する定義値
     */
    setFlagValue: function (flag, option) {
      return option[flag];
    },

    /**
     * 複数の要素を指定した件数毎に改行する
     * @param {string} itemString 表示する文字列
     * @param {number} itemsPerRow 1行当たりの個数(デフォルトは4)
     * @param {string} delimiter 区切り文字(デフォルトは半角空白)
     * @returns 表示する定義値
     */
    showItemsAsRow(itemString, itemsPerRow = 5, delimiter = ' ') {
      let items = []
      const itemsRow = []

      // 改行コード（\r\n, \r）を \n に統一
      itemString = itemString.replace(/\r\n|\r/g, '\n')

      // 区切り文字がスペースの場合
      if (delimiter === ' ') {
        // スペース・タブ・改行で分割し、分割した各文字列が空文字でない場合は要素に追加する
        items = itemString.split(/\s+/).filter(Boolean)
      }
      // 特定の区切り文字（カンマなど）の場合
      else {
        // 区切り文字で分割し、分割した各文字列の前後の空白を除去した文字列が空文字でない場合は要素に追加する
        items = itemString.split(delimiter).map(item => item.trim()).filter(Boolean)
      }

      // 指定した個数ごとにまとめてカンマ区切りの文字列にし、配列に格納する
      for (let i = 0; i < items.length; i += itemsPerRow) {
        const chunk = items.slice(i, i + itemsPerRow)
        itemsRow.push(chunk.join(', '))
      }

      return itemsRow
    },

    /**
     * 日付を指定した形式で表示する
     * @param  {string} datetime 表示する年月日
     * @param  {string} fromTime 表示する時刻（から）
     * @param  {string} toTime   表示する時刻（まで）
     * @returns string
     */
    showDateString(datetime, fromTime = '', toTime = '') {
      // 初期化
      let dispTime = '';               // 表示用文時刻
      const date = new Date(datetime); // 表示する日付

      // 日付が有効でない場合
      if (isNaN(date.getDate()) === true) {
        // 空文字を返す
        return ''
      }

      // 時刻の指定がある場合
      if (fromTime !== '' && toTime !== '' && isNaN(fromTime) === false && isNaN(toTime) === false) {
        // 指定した時刻（から）と時刻（まで）を「11:00 - 12:00」のような形式にフォーマットする
        dispTime = ' ' + fromTime + ':00 - ' + toTime + ':00'
      }

      // 曜日を生成する
      let day = ''
      switch (date.getDay()) {
        case 0:
          day = '日'
          break
        case 1:
          day = '月'
          break
        case 2:
          day = '火'
          break
        case 3:
          day = '水'
          break
        case 4:
          day = '木'
          break
        case 5:
          day = '金'
          break
        case 6:
          day = '土'
          break
        default:
      }
      return date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日(' + day + ')' + dispTime
    },

    /**
     * 数値を3桁ごとにカンマ区切りして通貨記号を先頭に付ける
     * @param {string|number} price 数値
     * @returns 3桁ごとにカンマ区切りして通貨記号を先頭に付けた数値
     */
    showPriceNumber: function (price) {
      let sPrice = ''
      if (typeof price === 'number' || typeof price === 'string') {
        sPrice = '￥ ' + Math.trunc(Number(price || 0)).toLocaleString()
      }
      return sPrice
    },

    /**
     * ファイルをダウンロードする処理
     * @param {string} path_name パス名
     * @param {string} file_name ファイル名
     */
    downloadFile(path_name, file_name) {
      // <a>要素を作成
      let link = document.createElement('a');
      // ファイルのパスを指定
      link.href = path_name;
      // ダウンロード時のファイル名を指定
      link.download = file_name;
      // ダウンロードを開始
      link.click();
      // <a>要素を削除
      link.remove();
    },
    /**
     * APIの共通したエラー処理
     * @param {object} error エラーレスポンス
     * @param {string} message システムエラー画面に表示する処理名
     * @param {string} route システムエラー画面の機能名(デフォルトはルート直下のシステムエラー)
     */
    apiError: function (error, message = '登録処理', route = '') {
      // 内部エラーの場合はシステムエラー画面へ遷移する
      if (error.response.status >= 500) {
        this.$router.push({
          name: route + "SystemError",
          params: {
            error_msg: message
          }
        })
      }
      // 未ログイン状態でログイン画面ではない場合はログイン画面へ遷移
      else if (error.response.status === 401 && this.$route.name !== 'Login') {
        this.$router.push({name: 'Login'})
      }
    },

    /**
     * 日付妥当性チェック
     *
     * @param {object} date 作業日付
     * @return 作業日付が有効日付である場合：true 作業日付が有効日付でない場合:false
     */
    checkValidDate: function (date) {
      // 日付の指定がある場合、日付が有効かチェックする
      if (date) {
        let strDate = date.date
        let checkDate = new Date(strDate)
        // 日付が有効である場合
        if (isNaN(checkDate.getDate()) !== true) {
          return true
        }
      }
      // 日付が有効ではない
      return false
    },

    /**
     * TOP画面までスクロールをする
     */
    pageTopScroll: function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },

    /**
     * アンカーまでスクロールする
     */
     scrollToAnchor (hash) {
      // アンカーのハッシュがある場合
      if (hash && hash.match(/^#.+$/)) {
        // 対象のIDまでスクロールする
        document.getElementById(hash.replace(/^#/, '')).scrollIntoView();
      }
    },

    /**
     * エラーメッセージをセットする
     * @param {*} error
     */
    setErrors(error) {
      // エラーメッセージをリセットする
      this.resetErrors()

      // サーバ停止、JSエラー等
      if (!error.response) {
        this.errors.push(lang_error[error.message] || lang_error[error.code] || error.message)
      }
      // CakePHP Exception
      else if (error.response.data && error.response.data.message) {
        this.errors.push(error.response.data.message)
      }
      // 入力エラー
      else if (error.response.data && error.response.data.error_list) {
        if (error.response.data.error_list.error) {
          for (let objError of error.response.data.error_list.error) {
            this.errors.push(objError.error_msg)
          }
        }
        else {
          for (let objError of error.response.data.error_list) {
            this.errors.push(objError.error_msg)
          }
        }
      }
      // その他エラー
      else {
        this.errors.push(error)
      }
    },

    /**
     * エラーメッセージをリセットする
     */
    resetErrors() {
      this.errors = []
    },

    /**
     * オブジェクトに要素があるかをチェックする
     * @param {object} checkObject チェックするオブジェクト
     * @return boolean true: 要素あり, false: 要素なし
     */
    isNotEmptyObject(checkObject) {
      return Object.keys(checkObject).length > 0
    },

    /**
     * 祝日を取得する
     */
    getHolidays() {
      return [
        "2022-01-01",
        "2022-01-10",
        "2022-02-11",
        "2022-02-23",
        "2022-03-21",
        "2022-04-29",
        "2022-05-03",
        "2022-05-04",
        "2022-05-05",
        "2022-07-18",
        "2022-08-11",
        "2022-09-19",
        "2022-09-23",
        "2022-10-10",
        "2022-11-03",
        "2022-11-23",
        "2022-12-28",
        "2022-12-29",
        "2022-12-30",
        "2022-12-31",
        "2023-01-01",
        "2023-01-02",
        "2023-01-03",
        "2023-01-09",
        "2023-02-11",
        "2023-02-23",
        "2023-03-21",
        "2023-04-29",
        "2023-05-03",
        "2023-05-04",
        "2023-05-05",
        "2023-07-17",
        "2023-08-11",
        "2023-09-18",
        "2023-09-23",
        "2023-10-09",
        "2023-11-03",
        "2023-11-23",
        "2023-12-28",
        "2023-12-29",
        "2023-12-30",
        "2023-12-31",
        "2024-01-01",
        "2024-01-02",
        "2024-01-03",
        "2024-01-08",
        "2024-02-11",
        "2024-02-12",
        "2024-02-23",
        "2024-03-20",
        "2024-04-29",
        "2024-05-03",
        "2024-05-04",
        "2024-05-05",
        "2024-05-06",
        "2024-07-15",
        "2024-08-11",
        "2024-08-12",
        "2024-09-16",
        "2024-09-22",
        "2024-09-23",
        "2024-10-14",
        "2024-11-03",
        "2024-11-04",
        "2024-11-23",
        "2024-12-30",
        "2024-12-31",
        "2025-01-01",
        "2025-01-02",
        "2025-01-03",
        "2025-01-13",
        "2025-02-11",
        "2025-02-23",
        "2025-02-24",
        "2025-03-20",
        "2025-04-29",
        "2025-05-03",
        "2025-05-04",
        "2025-05-05",
        "2025-05-06",
        "2025-07-21",
        "2025-08-11",
        "2025-09-15",
        "2025-09-23",
        "2025-10-13",
        "2025-11-03",
        "2025-11-23",
        "2025-11-24",
        "2025-12-29",
        "2025-12-30",
        "2025-12-31",
        "2026-01-01",
        "2026-01-02",
        "2026-01-12",
        "2026-02-11",
        "2026-02-23",
        "2026-03-20",
        "2026-04-29",
        "2026-05-04",
        "2026-05-05",
        "2026-05-06",
        "2026-07-20",
        "2026-08-11",
        "2026-09-21",
        "2026-09-22",
        "2026-09-23",
        "2026-10-12",
        "2026-11-03",
        "2026-11-23",
        "2026-12-28",
        "2026-12-29",
        "2026-12-30",
        "2026-12-31",
        "2027-01-01",
        "2027-01-11",
        "2027-02-11",
        "2027-02-23",
        "2027-03-22",
        "2027-04-29",
        "2027-05-03",
        "2027-05-04",
        "2027-05-05",
        "2027-07-19",
        "2027-08-11",
        "2027-09-20",
        "2027-09-23",
        "2027-10-11",
        "2027-11-03",
        "2027-11-23",
      ]
    },

    /**
     * 申し込み日からご利用開始希望日までの営業日を取得する
     */
    getPreparationDayCount() {
      return 3
    },

    /**
     * 商品コードと商品名を取得する
     */
    getItemList() {
      return {
        // セットプランの商品コード
        "KLITJST1MB001": "desknet's クラウド ライト",
        "KSTDJST1MB001": "desknet's クラウド スタンダード",
        "KPRMJST1MB001": "desknet's クラウド プレミアム",
        "KCLPJST1MB001": "desknet's クラウド チャットプラス",
        // NEOの商品コード: 商品名
        "KNEOJST1MB001": "グループウェア desknet's NEO",
        "KAPSJST1MB001": "業務アプリ作成ツール AppSuite", // 価格改定後
        "KAPPJST1MB001": "業務アプリ作成ツール AppSuite", // 価格改定前
        "KWEBJST1MB001": "desknet's NEO ウェブ会議",
        "KRMGJAC1MB000": "RoomMgr",
        "KEXPJST1MB001": "交通費経費精算",
        "KTMCJAC1MS000": "タイムカード + CLOUZA",
        "KTMAJAC1MS000": "有休管理＋申請承認オプション",
        "KNEDJAC1MS000": "ディスク増設", // 価格改定後
        "KHDDJAC1MS000": "ディスク増設", // 価格改定前
        "KSYSJAC1MB001": "Sync for smartphones",
        'KDRDJAC1MS000': "desknet'sドライブ ディスク増設",
        "KBATJAC1MS000": "BASIC認証",
        "KRIPJAC1MS000": "接続元IPアドレス制限",
        "KSBNJAC1MS000": "セキュアブラウザ 端末認証なし",
        "KSBDJAC1MS000": "セキュアブラウザ 端末認証あり",
        "SECURE_RE"    : "セキュアブラウザ 証明書再発行",
        "SECURE_IP"    : "セキュアブラウザ IP設定",
        "KCCNJAC1MS000": "クライアント認証",
        "KIPNJAC1MS000": "クライアント認証 IP設定",
        "KMLSJST1MB001": "WebARENA",
        "KMLSJCB1MB005": "メールボックス容量 5GB\n  (CYBERMAILΣ)",
        "KMLSJCB1MB010": "メールボックス容量 10GB\n  (CYBERMAILΣ)",
        "KMLSJCB1MB050": "メールボックス容量 50GB\n  (CYBERMAILΣ)",
        "KMLSJCB1MB100": "メールボックス容量 100GB\n  (CYBERMAILΣ)",
        "KMLSJCB1MAPLK": "情報漏えい対策\n  (CYBERMAILΣ)",
        "KMLSJCB1MAPEN": "添付ファイル暗号化・分離\n  (CYBERMAILΣ)",
        "KMLSJCB1MAA05": "メールアーカイブ＆監査 5年保存\n  (CYBERMAILΣ)",
        "KMLSJCB1MAA07": "メールアーカイブ＆監査 7年保存\n  (CYBERMAILΣ)",
        "KMLSJCB1MAA10": "メールアーカイブ＆監査 10年保存\n  (CYBERMAILΣ)",
        "KMLSJCB1MASBX": "クラウド型サンドボックス\n  (CYBERMAILΣ)",
        "KMLSJMG1MBVSS": "アンチウイルス・スパム＋サンドボックス\n   (MAILGATES Σ)",
        "KMLSJMG1MBPLK": "誤送信対策・審査\n (MAILGATES Σ)",
        "KMLSJMG1MBPEN": "添付ファイル暗号化・分離\n (MAILGATES Σ)",
        // ChatLuckの商品コード: 商品名
        "KCHTJST1MB001": "ビジネスチャット ChatLuck",
        "KCHTJAC1MS001": "ディスク増設",
        "KCTBJAC1MS000": "BASIC認証",
        "KCTIJAC1MS000": "接続元IPアドレス制限"
      }
    },

    /**
     * ログアウト時のログイン画面への画面遷移処理
     */
    moveToLoginPage() {
      // Cookieを取得する
      const sCookies = document.cookie
      // Cookieをキーごとに分ける
      const arCookies = sCookies.split(';')
      // ログイン画面の種類
      let login_display_type = ''

      // 各Cookieにログイン画面の種類が保存されているか探索する
      for (let sCookie of arCookies) {
        // Cookieをキーと値で分割する
        let arCookie = sCookie.split('=')
        // Cookieのキーがログイン画面の種類である場合
        if (arCookie[0].trim() === 'login_display_type') {
          // ログイン画面の種類のフラグ値を取得
          login_display_type = arCookie[1]
        }
      }

      // ログイン画面の種類がマスタパスワードログインの場合
      if (login_display_type === '1') {
        // NavigationDuplicatedエラー対策
        if (this.$route.name !== 'MasterLogin') {
          // マスタパスワードログイン画面へ遷移する
          this.$router.push({name: 'MasterLogin'})
        }
      }
      // それ以外の場合
      else {
        // NavigationDuplicatedエラー対策
        if (this.$route.name !== 'Login') {
          // ログイン画面へ遷移する
          this.$router.push({name: 'Login'})
        }
      }
    },

    /**
     * Cookieにログイン画面の種類を設定する
     * @param {string} loginDisplayType（'0':通常ログイン, '1':マスタパスワードログイン）
     */
    setCookieOfLoginType(loginDisplayType) {
      // cookieにログイン画面の種類のフラグをセットする
      // max-age = 寿命 (秒数) (1年 = 60*60*24*365 = 31536000秒)
      document.cookie = 'login_display_type=' + loginDisplayType + '; path= / ; max-age=31536000'
    },

    /**
     *  旧お申込フォームのURLを返す
     */
    returnOldApplicationFormUrl() {
      return "https://ssl.neo.co.jp/desknets/cloud/apply/dnservice_modindex/"
    },

    /**
     * 都道府県一覧を取得する
     */
    getPrefectureList() {
      return [
        { value: "", text: "（都道府県を選択してください。）" },
        { value: "北海道", text: "北海道" },
        { value: "青森県", text: "青森県" },
        { value: "岩手県", text: "岩手県" },
        { value: "宮城県", text: "宮城県" },
        { value: "秋田県", text: "秋田県" },
        { value: "山形県", text: "山形県" },
        { value: "福島県", text: "福島県" },
        { value: "茨城県", text: "茨城県" },
        { value: "栃木県", text: "栃木県" },
        { value: "群馬県", text: "群馬県" },
        { value: "埼玉県", text: "埼玉県" },
        { value: "千葉県", text: "千葉県" },
        { value: "東京都", text: "東京都" },
        { value: "神奈川県", text: "神奈川県" },
        { value: "新潟県", text: "新潟県" },
        { value: "富山県", text: "富山県" },
        { value: "石川県", text: "石川県" },
        { value: "福井県", text: "福井県" },
        { value: "山梨県", text: "山梨県" },
        { value: "長野県", text: "長野県" },
        { value: "岐阜県", text: "岐阜県" },
        { value: "静岡県", text: "静岡県" },
        { value: "愛知県", text: "愛知県" },
        { value: "三重県", text: "三重県" },
        { value: "滋賀県", text: "滋賀県" },
        { value: "京都府", text: "京都府" },
        { value: "大阪府", text: "大阪府" },
        { value: "兵庫県", text: "兵庫県" },
        { value: "奈良県", text: "奈良県" },
        { value: "和歌山県", text: "和歌山県" },
        { value: "鳥取県", text: "鳥取県" },
        { value: "島根県", text: "島根県" },
        { value: "岡山県", text: "岡山県" },
        { value: "広島県", text: "広島県" },
        { value: "山口県", text: "山口県" },
        { value: "徳島県", text: "徳島県" },
        { value: "香川県", text: "香川県" },
        { value: "愛媛県", text: "愛媛県" },
        { value: "高知県", text: "高知県" },
        { value: "福岡県", text: "福岡県" },
        { value: "佐賀県", text: "佐賀県" },
        { value: "長崎県", text: "長崎県" },
        { value: "熊本県", text: "熊本県" },
        { value: "大分県", text: "大分県" },
        { value: "宮崎県", text: "宮崎県" },
        { value: "鹿児島県", text: "鹿児島県" },
        { value: "沖縄県", text: "沖縄県" }
      ]
    },
    /**
     * 金額の表示や明細の表示に必要な商品の項目を返す
     */
    returnPaymentDetails() {
      return {
        // プランの商品
        light: {
          name: "desknet's クラウド ライト", type: "plan", count: 0, unit: "ユーザー", initial_cost: 0, monthly_unit_cost: 660
        },
        standard: {
          name: "desknet's クラウド スタンダード", type: "plan", count: 0, unit: "ユーザー", initial_cost: 0, monthly_unit_cost: 880
        },
        premium: {
          name: "desknet's クラウド プレミアム", type: "plan", count: 0, unit: "ユーザー", initial_cost: 0, monthly_unit_cost: 1100
        },
        chatplus: {
          name: "desknet's クラウド チャットプラス", type: "plan", count: 0, unit: "ユーザー", initial_cost: 0, monthly_unit_cost: 836
        },
        // desknet's NEO
        app_suite_user: {
          name: "業務アプリ作成ツール AppSuite", type: "neo", count: 0, unit: 'ユーザー', initial_cost: 0, monthly_unit_cost: 550
        },
        web_conferencing: {
          name: "desknet's NEO ウェブ会議", type: "neo", count: 0, unit: '会議室', initial_cost: 0, monthly_unit_cost: 11000
        },
        room_mgr: {
          name: "RoomMgr", type: "neo", count: 0, unit: '', initial_cost: 0, monthly_unit_cost: 22000
        },
        expense_settlement: {
          name: "交通費・経費精算", type: "neo", count: 0, unit: 'ユーザー', initial_cost: 0, monthly_unit_cost: 110
        },
        clouza: {
          name: "タイムカード＋CLOUZA", type: "neo", count: 0, unit: 'ユーザー', initial_cost: 0, monthly_unit_cost: 2200
        },
        neo_disk_size: {
          name: "ディスク増設", type: "neo", count: 0, unit: '20GB × ', initial_cost: 0, monthly_unit_cost: 2200, yearly_unit_cost: 26400
        },
        sync: {
          name: "Sync for smartphones", type: "neo", count: 0, unit: 'ユーザー', initial_cost: 0, monthly_unit_cost: 220
        },
        dn_drive_disk_size: {
          name: "desknet'sドライブ ディスク増設", type: 'neo', count: 0, unit: '20GB × ', initial_cost: 0, monthly_unit_cost: 2200, yearly_unit_cost: 26400
        },
        secure_browser_terminal_off: {
          name: "セキュアブラウザ", type: "neo", count: 0, unit: 'ユーザー', initial_cost: 0, monthly_unit_cost: 110
        },
        secure_browser_terminal_on: {
          name: "セキュアブラウザ", type: "neo", count: 0, unit: 'デバイス', initial_cost: 0, monthly_unit_cost: 385
        },
        client_auth: {
          name: "クライアント認証", type: "neo", count: 0, unit: 'デバイス', initial_cost: 0, monthly_unit_cost: 220
        },
        web_arena: {
          name: "メールサービス（WebARENA）", type: "neo", count: 0, unit: 'アカウント', initial_cost: 0, monthly_unit_cost: 220
        },
        cyber_account: {
          name: "メールサービス（CYBERMAILΣ）", type: "neo", count: 0, unit: 'アカウント', initial_cost: 55000, monthly_unit_cost: 220
        },
        cyber_dlp: {
          name: "情報漏えい対策", type: "neo", count: 0, unit: 'アカウント', initial_cost: 0, monthly_unit_cost: 220
        },
        cyber_dlp_separation: {
          name: "添付ファイル暗号化・分離", type: "neo", count: 0, unit: 'アカウント', initial_cost: 0, monthly_unit_cost: 110
        },
        cyber_archive: {
          name: "メールアーカイブ＆監査", type: "neo", count: 0, unit: 'アカウント', initial_cost: 0, monthly_unit_cost: 330
        },
        cyber_sandbox: {
          name: "クラウド型サンドボックス", type: "neo", count: 0, unit: 'アカウント', initial_cost: 0, monthly_unit_cost: 220
        },
        mailgates_init: {
          name: "MAILGATES Σ 初期費用", type: "neo", count: 0, unit: '', initial_cost: 55000, monthly_unit_cost: 0
        },
        mailgates_antivirus_sandbox: {
          name: "アンチウイルス・スパム＋サンドボックス（MAILGATES Σ）", type: "neo", count: 0, unit: 'アカウント', initial_cost: 0, monthly_unit_cost: 220
        },
        mailgates_prevent_missend: {
          name: "誤送信対策・審査（MAILGATES Σ）", type: "neo", count: 0, unit: 'アカウント', initial_cost: 0, monthly_unit_cost: 220
        },
        mailgates_separation: {
          name: "添付ファイル暗号化・分離（MAILGATES Σ）", type: "neo", count: 0, unit: 'アカウント', initial_cost: 0, monthly_unit_cost: 110
        },
        // ChatLuck
        chat_user: {
          name: "ビジネスチャット ChatLuck", type: "chat", count: 0, unit: 'ユーザー', initial_cost: 0, monthly_unit_cost: 330
        },
        chat_disk_size: {
          name: "ディスク増設", type: "chat", count: 0, unit: '20GB × ', initial_cost: 0, monthly_unit_cost: 1100, yearly_unit_cost: 12650
        }
      }
    },
    /**
     * 指定されたMIMEタイプでファイルとしてダウンロードする処理
     *
     * @param {string} binary_data バイナリデータ
     * @param {string} title       ファイル名
     * @param {string} mine_type   MINEタイプ
     */
    downloadBlobFile(binary_data, title, mine_type) {
      // 文字化け対策のため、BOMを作成する
      let bom = new Uint8Array([0xEF, 0xBB, 0xBF]);

      // Base64デコードしてBlobを作成
      let bin = atob(binary_data.replace(/^.*,/, ''));
      let buffer = new Uint8Array(bin.length);
      for (let i = 0; i < bin.length; i++) {
        buffer[i] = bin.charCodeAt(i);
      }
      let blob = new Blob([bom, buffer.buffer], {
        type: mine_type,
      });
      // Blobから一時的なオブジェクトURLを生成
      let url = URL.createObjectURL(blob);
      // ファイルをダウンロードする
      this.downloadFile(url, title)

      // ダウンロードが完了する前に解放されないように少し待つ
      setTimeout(() => {
        // オブジェクトURLを破棄してメモリを解放する
        URL.revokeObjectURL(url);
      }, 500);
    },
    /**
     * ひらがなをカタカナに変換する
     * @param {string} sHiragana ひらがな
     * @returns カタカナ
     */
    hiraToKana(sHiragana) {
      // ひらがな文字（Unicode: 3041〜3096）をカタカナ文字（Unicode: 30A1〜30F6）に変換する
      return sHiragana.replace(
        /[\u3041-\u3096]/g,
        function (match) {
          // ひらがなのUnicode値に0x60（96）を足すと対応するカタカナのUnicode値になる
          return String.fromCharCode(match.charCodeAt(0) + 0x60);
        }
      );
    },
    /**
     * 販売種別利用制限チェックを行う
     */
    validateSalesChannel () {
      // 販売種別利用制限チェック処理APIを呼び出し
      return c207CheckSalesChannel.view()
        .catch((err) => {
          // httpステータスコードが403の場合（権限エラー）
          if (err.response.status === 403) {
            // アプリケーションエラー画面へ遷移する
            this.$router.push({
              name: 'SupportApplicationError',
              params: {
                // 画面に表示するエラーメッセージ
                error_msg: this.forbidden_message
              }
            })
          }
          // システムエラーが発生した場合
          else {
            // 共通のエラー処理
            this.apiError(err, '画面表示処理', "Support")
          }
        })
    }
  }
}
